import { Injectable } from '@angular/core';
import {
  Action,
  SelectorOptions,
  State,
  StateContext,
  createSelector,
} from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { of } from 'rxjs';
import { finalize, switchMap, tap } from 'rxjs/operators';
import { FileService } from '../../services';
import { CoreFileLinkActions } from './file-link.action';

export interface FileLink {
  [key: string]: string;
}

export interface CoreFileLinkStateModel {
  fileLink: FileLink;
}
@State<CoreFileLinkStateModel>({
  name: 'coreFileLink',
  defaults: {
    fileLink: {},
  },
})
@Injectable()
@SelectorOptions({ injectContainerState: false })
export class CoreFileLinkState {
  constructor(private fileService: FileService) {}
  private requestsInProgress = {};
  static presentedFileLink(
    fileId: string,
  ): (state: CoreFileLinkStateModel) => string {
    return createSelector(
      [CoreFileLinkState],
      (state: CoreFileLinkStateModel) => state.fileLink[fileId],
    );
  }

  @Action(CoreFileLinkActions.FetchFileLink)
  fetchFileLink(
    { setState, getState }: StateContext<CoreFileLinkStateModel>,
    { fileId }: CoreFileLinkActions.FetchFileLink,
  ): any {
    const fileLink = getState().fileLink[fileId];
    if (fileLink) {
      return of(fileLink);
    }
    if (this.requestsInProgress[fileId]) {
      return;
    }
    this.requestsInProgress[fileId] = true;
    return this.fileService.getBlobByFileId(fileId).pipe(
      switchMap((blob) => {
        return this.fileService.blobToUrl(blob);
      }),
      tap((fileLink) => {
        setState(
          patch<CoreFileLinkStateModel>({
            fileLink: {
              ...getState().fileLink,
              [fileId]: fileLink,
            },
          }),
        );
      }),
      finalize(() => {
        this.requestsInProgress[fileId] = false;
      }),
    );
  }
}
